// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataset-group-tree{max-height:430px;overflow:auto}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/dataset-window/datasets-menu/dataset-groups/DatasetGroup.scss"],"names":[],"mappings":"AAAA,oBACE,gBAAA,CACA,aAAA","sourcesContent":[".dataset-group-tree {\n  max-height: 430px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
